<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span>Other Books from Bright Leaf</p>
<p class="seraft"><i>House Stories:</i> <i>The Meanings of Home in a New England Town</i></p>
<p class="serau">BETH LUEY</p>
<p class="serf"><i>Bricklayer Bill:</i> <i>The Untold Story of the Workingman’s Boston Marathon</i></p>
<p class="serau">PATRICK L. KENNEDY AND LAWRENCE W. KENNEDY</p>
<p class="serf"><i>Concrete Changes:</i> <i>Architecture, Politics, and the Design of Boston City Hall</i></p>
<p class="serau">BRIAN M. SIRMAN</p>
<p class="serf"><i>Williamstown and Williams College:</i> <i>Explorations in Local History</i></p>
<p class="serau">DUSTIN GRIFFIN</p>
<p class="serf"><i>Massachusetts Treasures</i>: <i>A Guide to Marvelous, Must-See Museums</i></p>
<p class="serau">CHUCK D’IMPERIO</p>
<p class="serf"><i>Boston’s Twentieth-Century Bicycling Renaissance</i>: <i>Cultural Change on Two Wheels</i></p>
<p class="serau">LORENZ J. FINISON</p>
<p class="serf"><i>Went to the Devil</i>: <i>A Yankee Whaler in the Slave Trade</i></p>
<p class="serau">ANTHONY J. CONNORS</p>
<p class="serf"><i>At Home</i>: <i>Historic Houses of Eastern Massachusetts</i></p>
<p class="serau">BETH LUEY</p>
<p class="serf"><i>Black Lives, Native Lands, White Worlds</i>: <i>A History of Slavery in New England</i></p>
<p class="serau">JARED ROSS HARDESTY</p>
<p class="serf"><i>At Home</i>: <i>Historic Houses of Central and Western Massachusetts</i></p>
<p class="serau">BETH LUEY</p>
<p class="serf"><i>Flight Calls</i>: <i>Exploring Massachusetts through Birds</i></p>
<p class="serau">JOHN R. NELSON</p>
<p class="serf"><i>Lost Wonderland</i>: <i>The Brief and Brilliant Life of Boston’s Million Dollar Amusement Park</i></p>
<p class="serau">STEPHEN R. WILK</p>
<p class="serf">I Believe I’ll Go Back Home: Roots and Revival in New England Folk Music</p>
<p class="serau">THOMAS S. CURREN</p>
<p class="serf">Legends of the Common Stream</p>
<p class="serau">JOHN HANSON MITCHELL</p>
<p class="serf">Mind and Hearts: The Story of James Otis Jr. and Mercy Otis Warren</p>
<p class="serau">Jeffrey H. Hacker</p>
<p class="serf"><i>The Combat Zone</i>: <i>Murder, Race, and Boston’s Struggle for Justice</i></p>
<p class="serau">JAN BROGAN</p>
<p class="serf"><i>Letters from Red Farm</i>: <i>The Untold Story of the Friendship between Helen Keller and Journalist Joseph Edgar Chamberlin</i></p>
<p class="serau">ELIZABETH EMERSON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma_Bane0003.vue?1e6b10bc